import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getVendorUserById } from './authActions';
import { Vendor, VendorResponse, VendorState } from './types';
import { persistor } from '..';

const initialState: VendorState = {
  vendorInfo: null,
  loading: false,
  error: null
};

const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    logout(state) {
      state.vendorInfo = null;
      state.error = null;
      persistor.purge();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVendorUserById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorUserById.fulfilled, (state, action: PayloadAction<VendorResponse>) => {
        state.loading = false;
        state.vendorInfo = action.payload.data;
        state.error = null;
      })
      .addCase(getVendorUserById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default vendorSlice.reducer;